// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".highlights[data-v-2ce2bee3]{display:flex;margin-top:5em;justify-content:space-around;margin-bottom:2em}@media only screen and (max-width:750px){.highlights[data-v-2ce2bee3]{flex-direction:column;align-items:center;font-size:260%}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
